"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO(2fd): add Docs
const react_1 = require("react");
function usePatchState(initialState) {
    const [state, setState] = (0, react_1.useState)(initialState);
    const patchState = (0, react_1.useCallback)((newState) => {
        return setState((current) => (Object.assign(Object.assign({}, current), newState)));
    }, []);
    return [state, patchState];
}
exports.default = usePatchState;
